// extracted by mini-css-extract-plugin
export default {"wrapper":"RouteAccess_wrapper__rjcSo"};